import Section, { SubSection } from './Section'
import i18n, { t, tStr } from '@utils/lang'

const Heb = () => (
  <Section>
    <SubSection img={<img src={`/images/${i18n.locale}/partOfHEB.png`} alt="" />} title={tStr('hebTitle_s')}>
      {t('hebBody_s')}
    </SubSection>
  </Section>
)

export default Heb
